import React from "react";
import useScreenshotStore from "./useScreenshotStore";
import Loading from "../Loading";
import Share from "../share/Share";

const Screenshot = () => {
  const {screenshotImg} = useScreenshotStore();

  return (
    // <div className="absolute inset-0 bg-white flex">
    <div className=" bg-white flex">
      {screenshotImg === "" ? (
        <Loading />
      ) : (
        <>
          <img
            className="p-1"
            src={screenshotImg}
            style={{maxHeight: "75vh"}}
          />
          <Share img={screenshotImg} />
        </>
      )}
    </div>
  );
};

export default Screenshot;
